import { useContentConfigForUserQuery } from '../graphQL';

type UseContentConfigReturn = {
  loading: boolean;
  executiveFunctioningContentEnabled: boolean;
  emotionalWellnessContentEnabled: boolean;
};

export const useContentConfig = (): UseContentConfigReturn => {
  const { data: contentConfigData, loading: contentConfigLoading } = useContentConfigForUserQuery();

  return {
    loading: contentConfigLoading,
    executiveFunctioningContentEnabled:
      contentConfigData?.contentConfigForUser.executiveFunctioningSkillsContentEnabled ?? false,
    emotionalWellnessContentEnabled:
      contentConfigData?.contentConfigForUser.emotionalWellnessSkillsContentEnabled ?? false,
  };
};
